export default "__VITE_ASSET__SEQHYho8__"